export default "__VITE_ASSET__0e0f7d7d__"